/**
 * A function to format the hash from the library url.
 */
export const formatHash = (libraryUrl: string | string[]) => {
  if (!libraryUrl) return;
  const levels = Array.isArray(libraryUrl) ? libraryUrl.slice(3) : [];

  if (!levels.length) {
    return;
  }

  if (levels.length > 3) {
    levels.pop();
  }

  const result = levels.reduce((result: string, level: string) => {
    const l = level?.replace(/-/g, '_') || '';
    const levelToAdd = result ? `_${l}` : l;
    return `${result}${levelToAdd}`;
  }, '');
  return decodeURIComponent(result);
};
